module.exports = __webpack_public_path__ + "img/cave39.0e9068ed.jpg";